<style>
._hcontent {
  height: 40px;
}
</style>
<script>
import axios from "axios";

import Layout from "../../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
let user = JSON.parse(localStorage.getItem("user"));
/**
 * Register component
 */
export default {
  page: {
    title: "Quản lý doanh số",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },

  data() {
    return {
      columns: [
        {
          label: "Người dùng",
          field: "user.username",
        },

        {
          label: "Tổng đơn",
          field: "n_order",
        },
        {
          label: "Thu nhập",
          field: "salary",
        },
        {
          label: "Thu nhập từ thuế",
          field: "tax_keep",
        },

        {
          label: "Hành Động",
          field: "_id",
          width: "80px",
        },
      ],
      rows: [],
      time: null,
      value: null,
    };
  },
  methods: {
    changerRefetch(date, type) {
      axios({
        url: process.env.VUE_APP_SERVER_URL + `/api/salary`,
        method: "post",
        headers: {
          authorization: user.token,
        },
        data: {
          date: this.value,
          uid: user.id,
        },
      }).then(({ data }) => {
        this.rows = data ? data : [];
      });
    },
  },

  async created() {
    if (user) {
      let { data } = await axios({
        url: process.env.VUE_APP_SERVER_URL + "/api/salary",
        method: "post",
        headers: {
          authorization: user.token,
        },
        data: {
          uid: user.id,
        },
      });

      this.rows = data ? data : [];
    }
  },
};
</script>

<template>
  <Layout>
    <PageHeader />

    <div class="mb-5">
      <div>
        <h3 class="h5">Quản lý doanh số</h3>
        <hr />
      </div>

      <div class="my-2">
        <el-date-picker
          v-model="value"
          type="datetimerange"
          align="right"
          @change="changerRefetch"
          start-placeholder="Ngày tháng bắt đầu"
          end-placeholder="Ngày tháng kết thúc"
        >
        </el-date-picker>
      </div>
      <vue-good-table
        :pagination-options="{
          enabled: true,
          rowsPerPageLabel: 'các mục trong trang',
          nextLabel: 'tiếp',
          prevLabel: 'trước',
          mode: 'records',
          allLabel: 'Tất cả',
        }"
        :line-numbers="true"
        :columns="columns"
        :rows="rows"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == '_id'">
            <button
              type="button"
              @click="
                $router.push({
                  path: '/thong-ke-doanh-so/' + props.row.user._id,
                })
              "
              class="btn btn-outline-info btn-sm"
            >
              <i class="bx bx-show-alt"></i>
            </button>
          </span>

          <span v-else-if="props.column.field == 'success'">
            <div v-if="props.row.success">
              {{ props.row.success ? props.row.success.norder_success : 0 }}

              <!-- <p class="_hcontent">
                <span>số đơn:</span>
                {{ props.row.success ? props.row.success.norder_success : 0 }}
              </p>
              <p class="_hcontent">
                <span> Cân nặng :</span> {{ props.row.success.lb_success }}
              </p>
              <p class="_hcontent">
                <span> Số thùng :</span> {{ props.row.success.label_success }}
              </p>
              <p class="_hcontent">
                <span> Doanh thu :</span> {{ props.row.success.total_success }}
              </p>
              <p class="_hcontent">
                <span> Thu nhập :</span> {{ props.row.success.salary_success }}
              </p> -->
            </div>
          </span>
          <span v-else-if="props.column.field == 'delay'">
            {{ props.row.delay ? props.row.delay.norder_delay : 0 }}

            <!-- <p class="_hcontent"> <span>số đơn:</span> {{props.row.delay ? props.row.delay.norder_delay : 0 }}</p>
                <p class="_hcontent"> <span> Cân nặng :</span> {{props.row.delay.lb_delay }}</p>
                <p class="_hcontent"> <span> Số thùng :</span> {{props.row.delay.label_delay }}</p>
                <p class="_hcontent"> <span> Doanh thu :</span> {{props.row.delay.total_delay }}</p>
                <p class="_hcontent"> <span> Thu nhập :</span> {{props.row.delay.salary_delay }}</p> -->
          </span>
          <span v-else-if="props.column.field == 'faild'">
            {{ props.row.faild ? props.row.faild.norder_faild : 0 }}
            <!-- <p class="_hcontent"> <span>số đơn:</span> {{props.row.faild ? props.row.faild.norder_faild : 0 }}</p>
                <p class="_hcontent"> <span> Cân nặng :</span> {{props.row.faild.lb_faild }}</p>
                <p class="_hcontent"> <span> Số thùng :</span> {{props.row.faild.label_faild }}</p>
                <p class="_hcontent"> <span> Doanh thu :</span> {{props.row.faild.total_faild }}</p>
                <p class="_hcontent"> <span> Thu nhập :</span> {{props.row.faild.salary_faild }}</p> -->
          </span>
        </template>
      </vue-good-table>
    </div>

    <!-- end row -->
  </Layout>
</template>